import { render } from "./BetsumaConfirm.vue?vue&type=template&id=ba55f14c&ts=true"
import script from "./BetsumaConfirm.vue?vue&type=script&lang=ts"
export * from "./BetsumaConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1364277118/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__